<template>
  <main class="login-layout">
    <form class="form-entrar" @submit.prevent="submitForm">
      <nav class="btn-voltar" aria-label="Navegação de retorno">
        <router-link to="/login">Voltar</router-link>
      </nav>

      <h1>Cadastro GEX</h1>

      <div v-if="!emailEnviado" class="form-etapa">
        <div class="input-group-container">
          <label for="name">Nome Completo:</label>
          <input id="name" v-model="formData.usuario.nome" type="text" placeholder="Digite seu Nome Completo"
            class="input-login" required />
        </div>

        <div class="input-group-container">
          <label for="email">E-mail:</label>
          <input id="email" v-model="formData.usuario.email" type="email" placeholder="Digite seu e-mail"
            class="input-login" required />
        </div>

        <div class="form-cpf">
          <div id="radio-estrangeiro" role="radiogroup" aria-label="Nacionalidade">
            <div class="radio-option">
              <input id="brasileiro" v-model="formData.usuario.estrangeiro" class="form-check-input" type="radio"
                :value="false" />
              <label class="form-check-label" for="brasileiro">
                Brasileiro (Brazilian)
              </label>
            </div>

            <div class="radio-option">
              <input id="estrangeiro" v-model="formData.usuario.estrangeiro" class="form-check-input" type="radio"
                :value="true" @click="formData.usuario.cpf = ''" />
              <label class="form-check-label" for="estrangeiro">
                Estrangeiro (Foreigner)
              </label>
            </div>
          </div>

          <div class="input-group-container">
            <label for="cpf">CPF:</label>
            <input id="cpf" v-model="formData.usuario.cpf" v-maska="'###.###.###-##'" type="text"
              placeholder="Digite seu CPF" class="input-login" :disabled="formData.usuario.estrangeiro"
              :required="!formData.usuario.estrangeiro" />
          </div>
        </div>
      </div>

      <div v-if="emailEnviado" class="form-etapa">
        <div id="div-validacao" class="card p-2 text-center" aria-live="polite">
          <h2>Um código de verificação foi enviado para seu e-mail</h2>

          <div id="otp" class="inputs d-flex flex-row justify-content-center mt-2">
            <input v-for="(digito, index) in 6" :key="index" :ref="(el) => (inputsRefs[index] = el)"
              v-model="codigo[index]" class="otp-input m-2 text-center form-control rounded" type="text" maxlength="1"
              :aria-label="`Dígito ${index + 1} do código de verificação`" @input="avancarFoco(index)"
              @keyup.delete="voltarFoco(index)" @paste="colarCodigo" v-maska="'#'" />
          </div>
        </div>

        <div class="input-group-container mt-3">
          <label for="nova-senha">Senha</label>
          <input id="nova-senha" v-model="senha" class="input-login" type="password" placeholder="Digite sua senha"
            @keyup="verificarSenha" required />
        </div>

        <div class="input-group-container">
          <label for="confirmar-nova-senha">Confirmar senha</label>
          <input id="confirmar-nova-senha" v-model="confirmacaoSenha" class="input-login" type="password"
            placeholder="Confirme sua senha" required />
        </div>

        <div class="alertas-senha" aria-live="assertive">
          <p v-if="senha !== confirmacaoSenha" class="text-erro">
            As senhas não são iguais
          </p>

          <p v-if="senha.length > 0 && (senha.length < 6 || senha.length > 36)" class="text-erro">
            A senha deve ter entre 6 e 36 caracteres
          </p>

          <p v-if="senha.includes(' ')" class="text-erro">
            A senha não pode conter espaços
          </p>

          <p v-if="senha.length > 0 && !possuiCaractereEspecial(senha)" class="text-erro">
            Sua senha deve conter pelo menos um caractere especial.
          </p>
        </div>
      </div>

      <button type="submit" class="submit-login" :disabled="carregando ||
        (emailEnviado && (
          !verificarSenha() ||
          senha !== confirmacaoSenha ||
          codigo.join('').length !== 6
        ))
        ">
        {{ carregando ? "Processando..." : "Avançar" }}
      </button>
    </form>

    <!-- Modal de avisos e confirmações -->
    <AvisoModal v-if="modal.visivel" :sucesso="modal.sucesso" :texto="modal.texto"
      :mostrar-botoes-login="modal.mostrarBotoesLogin" @fechar-modal="fecharModal" @login="irParaLogin" />
  </main>
</template>

<script>
import { vMaska } from "maska/vue";
import externosService from "@/service/externosService";
import controleDeAcessoService from "@/service/controleDeAcessoService";
import AvisoModal from "@/components/common/aviso.vue";
import router from "@/router";

export default {
  components: {
    AvisoModal,
  },

  data() {
    return {
      formData: {
        usuario: {
          nome: "",
          cpf: "",
          email: "",
          estrangeiro: false,
          telefone: "",
          dataNascimento: "",
          genero: null,
          heteroidentificacao: null,
          regra_id: null,
        },
        escolaridade: null,
        rendaFamiliar: null,
      },

      codigo: ["", "", "", "", "", ""],
      inputsRefs: [],
      senha: "",
      confirmacaoSenha: "",
      carregando: false,
      cadastroConcluido: false,
      emailEnviado: false,
      email: "",

      modal: {
        visivel: false,
        sucesso: false,
        texto: "",
        mostrarBotoesLogin: false,
      },
    };
  },

  methods: {
    abrirModal(texto, sucesso = false, mostrarBotoesLogin = false) {
      this.modal = {
        visivel: true,
        sucesso,
        texto,
        mostrarBotoesLogin,
      };
    },

    fecharModal() {
      this.modal.visivel = false;
    },

    irParaLogin() {
      this.fecharModal();
      router.push("/login/autenticacao-gex");
    },

    avancarFoco(index) {
      if (this.codigo[index] && index < 5) {
        const proximoInput = this.inputsRefs[index + 1];

        if (proximoInput) {
          proximoInput.focus();
        }
      }
    },

    voltarFoco(index) {
      if (!this.codigo[index] && index > 0) {
        const inputAnterior = this.inputsRefs[index - 1];

        if (inputAnterior) {
          inputAnterior.focus();
        }
      }
    },

    colarCodigo(event) {
      event.preventDefault();

      const textoColado = event.clipboardData.getData("text");

      if (!/^\d+$/.test(textoColado)) return;

      const digitos = textoColado.split("").slice(0, 6);

      digitos.forEach((num, i) => {
        this.codigo[i] = num;
      });

      const ultimoIndice = Math.min(digitos.length, 5);

      this.$nextTick(() => {
        this.inputsRefs[ultimoIndice]?.focus();
      });
    },

    possuiCaractereEspecial(senha) {
      const caracteresEspeciais = /[!@#$%^&*(),.?":{}_|<>;]/;
      return caracteresEspeciais.test(senha);
    },

    verificarSenha() {
      return (
        this.senha.length >= 6 &&
        this.senha.length <= 36 &&
        !this.senha.includes(" ") &&
        this.possuiCaractereEspecial(this.senha)
      );
    },

    async submitForm() {
      this.carregando = true;

      try {
        if (!this.cadastroConcluido) {
          if (this.formData.usuario.estrangeiro) {
            this.formData.usuario.cpf = null;
          }

          const response = await externosService.postExterno(this.formData);

          if (response) {
            this.cadastroConcluido = true;
            await this.enviarPincode();
          }
        } else {
          const pincode = this.codigo.join("");

          const cpfSemMascara = this.formData.usuario.cpf
            ? this.formData.usuario.cpf.replace(/\D/g, "")
            : this.formData.usuario.email;

          if (pincode && pincode.length === 6) {
            const data = {
              emailOrCpf: cpfSemMascara,
              pinCode: pincode,
              senha: this.senha,
            };

            const validacao =
              await controleDeAcessoService.validarPinCode(data);

            if (validacao === 200 || validacao?.status === 200) {
              this.abrirModal(
                "Senha criada com sucesso! Você já pode fazer seu login no GEX.",
                true,
                true
              );
            }
          } else {
            this.abrirModal(
              "Por favor, insira um código de verificação válido de 6 dígitos."
            );
          }
        }
      } catch (error) {
        console.error("Erro no cadastro:", error);

        const msg =
          error?.response?.data?.message ||
          error?.response?.data?.details ||
          error?.data?.message ||
          "Não foi possível processar o cadastro. Verifique os dados informados.";

        this.abrirModal(msg);
      } finally {
        this.carregando = false;
      }
    },

    async enviarPincode() {
      const cpfSemMascara = this.formData.usuario.cpf
        ? this.formData.usuario.cpf.replace(/\D/g, "")
        : this.formData.usuario.email;

      try {
        await controleDeAcessoService.gerarPinCode(cpfSemMascara);

        this.emailEnviado = true;
        this.email = this.formData.usuario.email;

        this.abrirModal(
          `Um código de confirmação foi enviado para o e-mail: ${this.email}.`,
          true
        );
      } catch (error) {
        console.error("Erro ao gerar PIN code:", error);

        this.emailEnviado = true;

        const msg =
          error?.response?.data?.message ||
          "O código de confirmação não pôde ser enviado agora. Verifique sua caixa de entrada ou aguarde alguns minutos.";

        this.abrirModal(msg);
      }
    },
  },

  directives: {
    maska: vMaska,
  },

  beforeUpdate() {
    this.inputsRefs = [];
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", Avenir, Helvetica, Arial, sans-serif;
}

.login-layout {
  background: linear-gradient(135deg,
      var(--roxo-primario) 0%,
      var(--roxo-primario) 100%);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.form-entrar {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  background: var(--branco);
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px hsla(0, 0%, 0%, 0.15);
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 420px;
  animation: fadeIn 0.4s ease-in-out;
}

.form-etapa {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.input-group-container {
  display: flex;
  flex-direction: column;
}

/* Links em contraste AAA */
a {
  font-weight: bold;
  text-decoration: none;
  color: var(--roxo-primario);
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

a:hover {
  color: var(--roxo-primario);
}

/* Título */
.form-entrar h1 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--roxo-primario);
  text-align: center;
}

#div-validacao h2 {
  font-size: 1rem;
  color: var(--cinza-escuro);
  font-weight: 600;
  margin-bottom: 0.5rem;
}

/* Botão voltar */
.btn-voltar a {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.8rem;
  background: var(--roxo-primario);
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--branco);
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-voltar a::before {
  content: "←";
  font-size: 0.9rem;
}

.btn-voltar a:hover {
  background: var(--roxo-medio);
  color: var(--branco);
}

.btn-voltar a:active {
  background: var(--roxo-primario);
}

/* Labels */
.form-entrar label {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--cinza-escuro);
  margin-bottom: 0.3rem;
  display: block;
}

/* Inputs e áreas de toque do Lighthouse (Mínimo 48px de altura) */
.input-login {
  width: 100%;
  height: 48px;
  padding: 0 1rem;
  border: 1px solid var(--cinza-claro);
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 400;
  color: var(--preto);
  outline: none;
  transition:
    border 0.3s ease,
    box-shadow 0.3s ease;
}

.input-login:focus {
  border-color: var(--roxo-medio);
  box-shadow: 0 0 0 3px hsla(258, 46%, 46%, 0.2);
}

.input-login:disabled {
  background-color: var(--cinza-claro);
  cursor: not-allowed;
}

/* Botão Cadastrar */
.submit-login {
  width: 100%;
  height: 60px;
  font-size: 1rem;
  font-weight: 600;
  color: var(--branco);
  background: var(--roxo-primario);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-login:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px hsla(258, 46%, 46%, 0.3);
}

.submit-login:disabled {
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Opções de Rádio com espaçamento otimizado */
#radio-estrangeiro {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-bottom: 0.5rem;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 32px;
}

.form-check-label {
  color: var(--cinza-escuro);
  cursor: pointer;
}

.form-check-input {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* Alertas de validação de senha */
.alertas-senha {
  margin-top: 0.5rem;
}

.text-erro {
  color: var(--vermelho);
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 0.2rem;
}

/* Caixa OTP */
#otp .otp-input {
  width: 48px;
  height: 48px;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
  background-color: var(--branco);
  border: 2px solid var(--cinza-claro);
  border-radius: 8px;
  transition: all 0.25s ease;
}

#otp .otp-input:focus {
  outline: none;
  background-color: var(--branco);
  border-color: var(--roxo-medio);
  box-shadow: 0 0 0 3px hsla(258, 46%, 46%, 0.2);
  transform: scale(1.05);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 500px) {
  .form-entrar {
    padding: 2rem 1.2rem;
  }

  .form-entrar h1 {
    font-size: 1.5rem;
  }
}
</style>
